export default __webpack_public_path__ + "static/media/Logotip.d8de3bcd.svg";